import { render } from "./LeaderboardTab.vue?vue&type=template&id=455c2b41&scoped=true"
import script from "./LeaderboardTab.vue?vue&type=script&lang=js"
export * from "./LeaderboardTab.vue?vue&type=script&lang=js"

import "./LeaderboardTab.vue?vue&type=style&index=0&id=455c2b41&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455c2b41"]])

export default __exports__